import NotificationManual from '@/api/notification-manual'
import ProgramMain from '@/api/main-program'
import ProgramSub from '@/api/sub-program'
import Grade from '@/api/grade'
import { baseState, baseMutations } from '@/store/mixins'

export const state = {
  ...baseState,
  mainPrograms: [],
  subPrograms: [],
  grades: []
}

export const getters = {}

export const mutations = {
  ...baseMutations,
  RECEIVE_PROGRAM_MAINS(state, data) {
    state.mainPrograms = data
  },
  RECEIVE_PROGRAM_SUBS(state, data) {
    state.subPrograms = data
  },
  RECEIVE_GRADES(state, data) {
    state.grades = data
  }
}

export const actions = {
  fetch(context, attrubutes = {}) {
    let params = Object.assign(
      {
        page: context.state.pagination.page,
        perPage: context.state.pagination.perPage,
        search: context.state.search
      },
      attrubutes
    )
    return NotificationManual.get({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response)
      return Promise.resolve(response)
    })
  },
  send(context, data) {
    return NotificationManual.store(data)
  },
  update(context, { sstc_id, ...data }) {
    return NotificationManual.update(
      sstc_id,
      Object.assign({}, data, {
        total_hours: parseFloat(data.total_hours)
      })
    )
  },
  destroy(context, id) {
    return NotificationManual.destroy(id)
  },
  fetchProgramMain(context, attributes = {}) {
    return ProgramMain.get({
      headers: {
        'X-PERMISSION-ALLOW-CODE': context.rootGetters.permissionAllowCode
      },
      params: {
        page: -1,
        fields: {
          academic_program_mains: 'acp_id,acp_name_native,acp_name_foreign'
        },
        ...attributes
      }
    }).then(response => {
      return Promise.resolve(response)
    })
  },
  fetchProgramSub(context, attributes = {}) {
    return ProgramSub.get({
      headers: {
        'X-PERMISSION-ALLOW-CODE': context.rootGetters.permissionAllowCode
      },
      params: {
        page: -1,
        fields: {
          academic_program_subs: 'acps_id,acps_name_native,acps_name_foreign'
        },
        filter: {
          acp_id: attributes.acp_id
        },
        ...attributes
      }
    }).then(response => {
      return Promise.resolve(response)
    })
  },
  fetchGrade(context, attributes = {}) {
    if (attributes.acps_id.length == 0) return
    return Grade.get({
      headers: {
        'X-PERMISSION-ALLOW-CODE': context.rootGetters.permissionAllowCode
      },
      params: {
        page: -1,
        fields: {
          academic_program_level_grades: 'grade_id,grade_name_foreign'
        },
        filter: {
          by_sub_program: attributes.acps_id
        },
        ...attributes
      }
    }).then(response => {
      return Promise.resolve(response)
    })
  }
}
